import ContactTagAppliedDisplay from './ContactTagAppliedDisplay.container'
import ContactTagAppliedForm from './ContactTagAppliedForm.container'
import IconTagAdded from 'components/Icons/TagAdded'

export default {
  id: 'contact_tag_added',
  label: 'Contact Tagged',
  helpUrl: 'https://help.thinkpickle.com.au/flows/triggers/contact_tag_added',
  icon: IconTagAdded,
  inputs: [],
  outputs: [{}],
  display: ContactTagAppliedDisplay,
  form: ContactTagAppliedForm,
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/ContactTagApplied/index.js